/*!
 * bs5-jquery-compat.js
 * jQuery-method bridge for legacy theme code running on Bootstrap 5.
 * Maps $(el).modal('show'), .tab('show'), .tooltip(), .collapse() etc. to the
 * matching Bootstrap 5 component instance, since BS5 dropped jQuery plugins.
 * Loaded after bootstrap.bundle.min.js and vendor.js (jQuery), before theme.min.js.
 */
(function () {
  'use strict';
  if (typeof window.jQuery === 'undefined' || typeof window.bootstrap === 'undefined') return;

  var $ = window.jQuery;
  var map = {
    modal: 'Modal',
    dropdown: 'Dropdown',
    collapse: 'Collapse',
    tab: 'Tab',
    tooltip: 'Tooltip',
    popover: 'Popover',
    carousel: 'Carousel',
    button: 'Button',
    alert: 'Alert',
    toast: 'Toast',
    scrollspy: 'ScrollSpy'
  };

  Object.keys(map).forEach(function (method) {
    var Component = window.bootstrap[map[method]];
    if (!Component || typeof $.fn[method] !== 'undefined') return;

    $.fn[method] = function (action, config) {
      var returned;
      this.each(function () {
        var instance = Component.getOrCreateInstance(this, config);
        if (typeof action === 'number' && method === 'carousel') {
          returned = instance.to(action);
        } else if (typeof action === 'string' && typeof instance[action] === 'function') {
          returned = instance[action]();
        } else if (action === undefined && method === 'collapse') {
          // BS4 default action for a bare .collapse() call
          instance.toggle();
        }
      });
      return returned === undefined ? this : returned;
    };

    $.fn[method].Constructor = Component;
  });

  if ($.fn.modal) $.fn.modal.VERSION = (window.bootstrap.Modal && window.bootstrap.Modal.VERSION) || '5.3.3';
})();
